module.exports = __webpack_public_path__ + "img/lachsrollenvonoben.b7c524b6.jpg";